class NotImplementedError extends Error {
  constructor(m: string) {
    super(m);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, NotImplementedError.prototype);
  }
}

export default NotImplementedError;
